import React, {useState, useEffect} from 'react';
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import { updateQuestionTemplate } from "../../../actions/questionEditorActions";
import { getTagList } from "../../../actions/tagActions";
import { validateTagNameUnique } from "../../../actions/tagEditorActions";
import ArgoTextFieldHook from "../../common/ArgoTextFieldHook";
import ArgoButtonHook from "../../common/ArgoButtonHook";
import * as Colors from "@mui/material/colors";
import ArgoMultipleSelectCheckmarksHook from "../../common/ArgoMultipleSelectCheckmarksHook";
import {pageableObjFromFilter} from "../../../utilities/PageableAndFilterUtilities";
import * as TEMPLATE from "../../../constants/templateConstants";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";


const TagSelectOrCreateHook = ({ questionDepth = 0, allowCreate = true, filterMode = false, selectedTags = [] }) => {
    // Convert class state to hooks
    const [tagName, setTagName] = useState("");
    const [tagNameErrorText, setTagNameErrorText] = useState("");
    const [isExistingTag, setIsExistingTag] = useState(true);

    // Redux selectors
    const questionTemplate = useSelector(state => state.questionEditor[questionDepth].template);
    const storeTagList = useSelector(state => state.tagList);
    const filterTags = useSelector(state => state.filter[TEMPLATE.FILTER.all.selectExistingTags]);
    const options = useSelector(state => state.tagEditor.options);

    // Redux dispatch
    const dispatch = useDispatch();

    // ComponentDidMount equivalent
    useEffect(() => {
        dispatch(getTagList(pageableObjFromFilter(filterTags), filterTags));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Empty dependency array means this runs once on mount

    // ComponentWillReceiveProps equivalent
    // useEffect(() => {
    //     if (tagList.length === 0) {
    //         let newTagList = [];
    //         for (let i = 0; i < storeTagList.length; i++) {
    //             let foundRow = questionTemplate.searchTags.filter(row => storeTagList[i].name === row.name);
    //             if (foundRow.length === 0) {
    //                 newTagList.push({ value: i.toString(), text: storeTagList[i].name });
    //             }
    //         }
    //         setTagList(newTagList);
    //     }
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [storeTagList, questionTemplate.searchTags]);

    const validateTag = (name) => {
        let errorText = " ";

        if (name.length === 0) {
            errorText = "Tag name cannot be blank.";
        } else {
            let nameExists = false;
            storeTagList.forEach(tag => {
                if (tag.name.toUpperCase() === name.toUpperCase()) {
                    nameExists = true;
                }
            });
            selectedTags.forEach(tag => {
                if (tag.name.toUpperCase() === name.toUpperCase()) {
                    nameExists = true;
                }
            });
            if (nameExists) {
                errorText = "Tag already exists.";
            }
        }

        setTagNameErrorText(errorText);
    };

    const onToggleChangeIsExistingTag = (event) => {
        const value = event.target.checked;

        if (value) {
            validateTag(""); // Tag should be empty string on change to existing tag = NO
        }

        setIsExistingTag(!value);
        setTagName("")
    };

    const onTextChangeNewTagName = (event) => {
        const value = event.target.value;
        dispatch(validateTagNameUnique(value));
        setTagName(value);
        validateTag(value);
    };

    const createNewTagAndAddToQuestion = () => {
        const newTag = {
            id: "",
            name: tagName,
            checked: true
        };

        // let assignedTags = questionTemplate.searchTags;

        // if (assignedTags.find(tag => tag.name === newTag.name)) {
        //     setTagName("");
        //     return;
        // }

        // let found = storeTagList.find(tag => tag.name === newTag.name);

        // if (found) {
        //     addExistingTagToQuestion(null, "", newTag.name);
        // } else {
        let updatedTemplate = { ...questionTemplate };
        updatedTemplate.searchTags = [...updatedTemplate.searchTags, newTag];
        dispatch(updateQuestionTemplate(updatedTemplate, questionDepth));
        // }

        setIsExistingTag(true);
    };

    const handleSelectTagsOnChange = (event, fieldName, tagList) => {
        addExistingTagToQuestion(event, fieldName, tagList);
    }

    const addExistingTagToQuestion = (event, fieldName, tagList) => {
        let checkedTags = tagList.filter(tag => tag.checked)
        let updatedTemplate = { ...questionTemplate };
        updatedTemplate.searchTags = checkedTags;
        dispatch(updateQuestionTemplate(updatedTemplate, questionDepth));
        setIsExistingTag(true);
    };

    // const removeTagAssignedToQuestion = (event, tagLabel, tagIndex) => {
    //     let updatedTemplate = { ...questionTemplate };
    //     let tags = [...updatedTemplate.searchTags];
    //     let removedTagObj = tags[tagIndex];
    //
    //     updatedTemplate.searchTags = tags.filter((value, index) => index !== tagIndex);
    //     dispatch(updateQuestionTemplate(updatedTemplate, questionDepth));
    //
    //     if (removedTagObj.id !== "") {
    //         let tagListCopy = [...tagList];
    //         tagListCopy.push({ value: "", text: removedTagObj.name });
    //
    //         tagListCopy.sort((a, b) => {
    //             let fa = a.text.toLowerCase(),
    //                 fb = b.text.toLowerCase();
    //
    //             if (fa < fb) return -1;
    //             if (fa > fb) return 1;
    //             return 0;
    //         });
    //
    //         for (let i = 0; i < tagListCopy.length; i++) {
    //             tagListCopy[i].value = i.toString();
    //         }
    //
    //         setTagList(tagListCopy);
    //     }
    // };

    // const tagsAssignedToQuestion = ((questionTemplate !== undefined) && (questionTemplate.searchTags !== undefined))
    //     ? questionTemplate.searchTags
    //     : [];

    return (
        <div id="TagSelectOrCreate-container-div">
            {allowCreate ? (
                <FormControlLabel
                    id="toggleKey"
                    style={{margin: "0px"}}
                    control={
                        <Switch
                            color="primary"
                            checked={!isExistingTag}
                            onChange={onToggleChangeIsExistingTag}
                        />
                    }
                    label="Create new tag?"
                    labelPlacement="start"
                />
            ) : ""}

            {isExistingTag ? (
                storeTagList.length > 0 ? (
                    <ArgoMultipleSelectCheckmarksHook
                        fileName="TagSelectOrCreateHook"
                        fieldName="selectedTags"
                        label={"Tags"}
                        width={"100%"}
                        dropDownWidth={filterMode ? 250 : 1000}
                        dropDownHeight={200}
                        valueProperty="id"
                        textProperty="name"
                        menuItems={storeTagList}
                        onChange={handleSelectTagsOnChange}
                        selectedTags={selectedTags}
                    />
                ) : (
                    <div style={{ color: "gray" }}>There are no existing tags.</div>
                )
            ) : (
                <div id="TagSelectOrCreate-create-container-div" 
                     style={{
                         display: "flex", 
                         flexDirection: "row", 
                         alignItems: "center", 
                         height: "72px", 
                         marginLeft: "32px", 
                         width: "100%"
                     }}>
                    <div style={{ display: "flex", width: "100%" }}>
                        <ArgoTextFieldHook
                            fileName="TagSelectOrCreate"
                            fieldName="tagName"
                            label='Name'
                            value={tagName}
                            onChange={onTextChangeNewTagName}
                            width="250px"
                            maxLength={15}
                            errorText={tagNameErrorText}
                        />

                        <div style={{ width: "20px" }}>&nbsp;</div>

                        <ArgoButtonHook
                            fileName="TagSelectOrCreate"
                            fieldName="add"
                            variant="contained"
                            label="ADD"
                            onClick={createNewTagAndAddToQuestion}
                            disabled={tagNameErrorText !== " " || options.isValidating}
                            width="100px"
                            paddingTop="10px"
                            containedTextColor={'white'}
                            containedBgColor={Colors.blue[500]}
                            containedHoverTextColor={'#010203'}
                            containedHoverBgColor={Colors.blue[500]}
                        />

                        <div style={{ width: "15px" }}>&nbsp;</div>

                        <div style={{ color: "darkgray", paddingTop: "18px" }}>
                            Note: Tag is not created unless question is saved.
                        </div>
                    </div>
                </div>
            )}

            <div style={{ width: "20px" }}>&nbsp;</div>
        </div>
    );
};

TagSelectOrCreateHook.propTypes = {
    questionDepth: PropTypes.number,
    allowCreate: PropTypes.bool,
    filterMode: PropTypes.bool,
    resetTags: PropTypes.bool,
    selectedTags: PropTypes.array
};

export default TagSelectOrCreateHook;